<template>
  <v-card :class="{['bg-inner']: true, alerta}" :elevation="$$_elevacao">
    <v-card-title>
      <titulo-questao :numero="numero" :nome="detalhe.foqnome" :obrigatorio="detalhe.foqobrigatorio === 'S'" />
    </v-card-title>
    <v-card-subtitle>
      {{detalhe.foqdescricao}}
    </v-card-subtitle>
    <v-card-text>
      <template v-for="(item, index) in detalhe.opcoes">
        <v-checkbox :label="item.fqodescricao" :value="item.id" :key="item.id" v-model="value[index]">
        </v-checkbox>
      </template>

      <template v-if="(detalhe && detalhe.subquestoes && detalhe.subquestoes.length > 0) && !complemento">
        <template v-for="(subitem, index) in detalhe.subquestoes">
          <div :key="subitem.id">
            <v-divider></v-divider>
            <component
            :is="componenteCard(subitem.foqtipo)"
            :key="subitem.id"
            :ref="`subquestao-${index + 1}`"
            :detalhe="subitem"
            :complemento="true"
            >
            </component>
          </div>
        </template>
      </template>

    </v-card-text>
  </v-card>
</template>

<script>
import errorHandler from '../../utils/error-handler';
import { componenteCard } from '../../utils/tipo-card';
import TituloQuestao from '../TituloQuestao.vue';

export default {
  name: 'card-check',

  components: {
    TituloQuestao,
  },

  data() {
    return {
      value: [],
      alerta: false,
      resposta: null,
    };
  },

  methods: {
    componenteCard,
    $_alerta() {
      this.alerta = true;
      errorHandler(`${this.$props.detalhe.foqnome} é obrigatória!`);
    },
  },

  computed: {
    $$_elevacao() {
      return (this.$props.complemento) ? 5 : 0;
    },
  },
  mounted() {
    if (this.detalhe.resposta) {
      const { resposta, opcoes } = this.detalhe;
      const opcaoMap = {};
      opcoes.forEach(({ id }) => {
        const [res] = resposta.filter(({ forresposta }) => forresposta === id);
        opcaoMap[id] = res && res.forresposta;
      });
      const respostas = Object.values(opcaoMap);
      this.value = respostas;
    }
  },

  props: {
    // Ordem da questão no formulário (ex.: "1-2"), calculada pelo Checklist.
    // Subquestões (complemento) não recebem.
    numero: {
      type: String,
      default: null,
    },
    detalhe: Object,
    complemento: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    value(valor) {
      const checker = valor.every((v) => v === false);
      if (!checker) {
        this.alerta = false;
      }
    },
  },
};
</script>

<style scoped>
  .bg-inner {
    width: 100%;
    background-color: #ffffff;
    border-radius: 15px;
    margin-top: 25px;
  }

  .obrigatorio {
    color: red;
    padding-left: 5px;
  }

  .alerta {
    border: 1px solid red;
    animation: vibracao 0.5s;
  }

  @keyframes vibracao {
    0% { transform: translateX(10px); }
    25% { transform: translateX(-10px); }
    50% { transform: translateX(10px); }
    75% { transform: translateX(-10px); }
    100% { transform: translateX(0px); }
  }
</style>
